import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CheckboxComponent } from '../core/controls/checkbox.component';
import { DatePickerComponent } from '../core/controls/date-picker.component';
import { InputComponent } from '../core/controls/input.component';
import {
  Operator,
  OperatorInputComponent,
} from '../core/controls/operator-input.component';
import { RadioButtonComponent } from '../core/controls/radio-button.component';
import { SelectComponent } from '../core/controls/select.component';
import { TextareaComponent } from '../core/controls/textarea.component';
import { ToggleSwitchComponent } from '../core/controls/toggle-switch.component';

@Component({
  selector: 'app-form-prime-design',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputComponent,
    DatePickerComponent,
    SelectComponent,
    TextareaComponent,
    RadioButtonComponent,
    CheckboxComponent,
    ToggleSwitchComponent,
    OperatorInputComponent,
  ],
  template: `
    <div class="tw-p-8 tw-flex tw-flex-wrap">
      <div class="tw-w-[80px]">
        <app-input
          [control]="fg.controls.integer"
          label="number"
          type="Integer"
          helpText="number"
        ></app-input>
      </div>
      <app-operator-input
        [control]="fg.controls.account"
        [operatorControl]="fg.controls.accountOp"
        [operators]="accountOperators"
      />
      <app-operator-input
        [control]="fg.controls.unit"
        [operatorControl]="fg.controls.unitOp"
        [operators]="unitOperators"
      />
    </div>
    <div class="tw-p-8 tw-flex tw-flex-wrap">
      <app-input
        [control]="fg.controls.firstName"
        label="First name"
        helpText="Your first name"
      ></app-input>
      <app-input
        [control]="fg.controls.lastName"
        label="Last name"
        helpText="Your last name"
      ></app-input>
      <app-date-picker
        [control]="fg.controls.birthDate"
        label="Birth date"
        helpText="Your birth date"
      ></app-date-picker>
      <app-select
        [control]="fg.controls.country"
        label="Country"
        optionLabel="name"
        optionValue="code"
        [options]="countries"
        helpText="Your country"
      ></app-select>
      <app-select
        [control]="fg.controls.countries"
        label="Countries"
        optionLabel="name"
        optionValue="code"
        [options]="countries"
        helpText="Countries you've visited"
        [multiple]="true"
      ></app-select>
      <app-textarea
        [control]="fg.controls.comment"
        label="Comment"
        helpText="Leave a comment"
      ></app-textarea>
      <app-radio-button
        [control]="fg.controls.radioCountry"
        label="Country"
        optionLabel="name"
        optionValue="code"
        [options]="countries"
        helpText="Your country"
      ></app-radio-button>
      <app-checkbox
        label="I Agree"
        [control]="fg.controls.agreeCheck"
        helpText="Check to agree"
      />
      <app-toggle-switch
        label="Show advanced settings"
        [control]="fg.controls.showAdvanced"
      />
    </div>
    <div>
      {{ fg.value | json }}
    </div>
  `,
  styles: [``],
})
export class FormPrimeDesignComponent {
  fg = new FormGroup({
    account: new FormControl<string>(''),

    accountOp: new FormControl<string>('sw'),

    unit: new FormControl<string>(''),

    unitOp: new FormControl<string>('ew'),

    firstName: new FormControl<string>('', Validators.required),
    lastName: new FormControl<string>('', Validators.required),
    birthDate: new FormControl<Date | null>(null, Validators.required),
    country: new FormControl<string | null>(null, Validators.required),
    countries: new FormControl<string[] | null>(null, Validators.required),
    comment: new FormControl<string>('', Validators.required),
    radioCountry: new FormControl<string>('', Validators.required),
    agreeCheck: new FormControl<boolean>(false, Validators.required),
    showAdvanced: new FormControl<boolean>(false),
    integer: new FormControl<number>(0),
  });

  accountOperators: Operator[] = [
    {
      key: 'eq',
      placeholder: 'Account',
      label: 'Equals',
    },
    {
      key: 'contains',
      placeholder: 'Account contains',
      label: 'Contains',
    },
    {
      key: 'sw',
      placeholder: 'Account starts with',
      label: 'Starts with',
    },
    {
      key: 'ew',
      placeholder: 'Account ends with',
      label: 'Ends with',
    },
  ];

  unitOperators: Operator[] = [
    {
      key: 'eq',
      placeholder: 'Unit',
      label: 'Equals',
    },
    {
      key: 'contains',
      placeholder: 'Unit contains',
      label: 'Contains',
    },
    {
      key: 'sw',
      placeholder: 'Unit starts with',
      label: 'Starts with',
    },
    {
      key: 'ew',
      placeholder: 'Unit ends with',
      label: 'Ends with',
    },
  ];

  title = 'prime-ng-demo';

  countries = [
    { name: 'Australia', code: 'AU' },
    { name: 'Brazil', code: 'BR' },
    { name: 'China', code: 'CN' },
    { name: 'Egypt', code: 'EG' },
    { name: 'France', code: 'FR' },
    { name: 'Germany', code: 'DE' },
    { name: 'India', code: 'IN' },
    { name: 'Japan', code: 'JP' },
    { name: 'Spain', code: 'ES' },
    { name: 'United States', code: 'US' },
  ];
}
